<template>
  <teleport to="body">
    <div class="fixed top-4 right-4 z-[70] flex flex-col gap-2 max-w-sm w-full pointer-events-none">
      <transition-group
        enter-active-class="transition-all duration-300 ease-out"
        enter-from-class="opacity-0 translate-x-6"
        enter-to-class="opacity-100 translate-x-0"
        leave-active-class="transition-all duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0 translate-x-6">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="pointer-events-auto bg-surface border border-line rounded-xl shadow-flyout px-4 py-3 relative flex items-start gap-3 group">
          <div class="flex-1 min-w-0">
            <p class="text-sm font-semibold text-ink pr-6">{{ toast.title }}</p>
            <p
              v-if="toast.content"
              class="text-xs text-muted mt-0.5 pr-6 leading-relaxed">
              {{ toast.content }}
            </p>
          </div>
          <button
            class="absolute top-3 right-3 text-muted hover:text-ink hover:bg-surfaceAlt p-1 rounded-lg transition-colors"
            @click="dismiss(toast.id)">
            <X class="w-3.5 h-3.5" />
          </button>
        </div>
      </transition-group>
    </div>
  </teleport>
</template>

<script>
import { computed, watch, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { X } from '@lucide/vue'

export default {
  name: 'Notification',
  components: {
    X,
  },
  setup() {
    const store = useStore()
    const toasts = computed(() => store.state.toasts)

    const activeTimeouts = new Map()

    watch(
      toasts,
      newToasts => {
        if (!newToasts) return

        // Schedule timeouts for new toasts
        newToasts.forEach(toast => {
          if (toast.id && !activeTimeouts.has(toast.id)) {
            const timeoutId = setTimeout(() => {
              dismiss(toast.id)
            }, 5000)
            activeTimeouts.set(toast.id, timeoutId)
          }
        })

        // Clean up timeouts for toasts that were already removed
        for (const [toastId, timeoutId] of activeTimeouts.entries()) {
          if (!newToasts.some(t => t.id === toastId)) {
            clearTimeout(timeoutId)
            activeTimeouts.delete(toastId)
          }
        }
      },
      { immediate: true, deep: true }
    )

    const dismiss = toastId => {
      store.commit('removeToast', toastId)
    }

    onUnmounted(() => {
      // Clean up all timeouts when component is unmounted
      for (const timeoutId of activeTimeouts.values()) {
        clearTimeout(timeoutId)
      }
      activeTimeouts.clear()
    })

    return {
      toasts,
      dismiss,
    }
  },
}
</script>
